import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";


const useJobsMatrixData = () => {
  const isJobDetailsDialogOpen = useSelector(
    (state: StoreType) => state.jobsMatrix?.isJobDetailsDialogOpen
  ) ?? false;

  const jobStatusUpdateError = useSelector(
    (state: StoreType) => state.jobsMatrix?.fetchWorkerJobAuditLog.errorMessage
  ) ?? null;

  const filterData = useSelector(
    (state: StoreType) => state.jobsMatrix?.filterData
  ) ?? {};

  return {
    isJobDetailsDialogOpen,
    jobStatusUpdateError,
    filterData,
  };
};

export default useJobsMatrixData;